import 'normalize.css';
import './style.css';
import './global';
import * as Bowser from 'bowser'; 

const importAll = (r) => { r.keys().forEach(r) };
importAll(require.context('./components', true, /\.tag$/));

(() => {
  let lastTime = null;
  const browser = Bowser.getParser(window.navigator.userAgent);
  window.onerror = (msg, file, line, col, err) => {
    const errMessage = `${msg}
URL: ${location.href}
ファイル名: ${file}
環境: ${browser.getBrowserName()} ${browser.getBrowserVersion()} | ${browser.getOSName()} ${browser.getOSVersion()} ${browser.getPlatformType()}
${navigator.userAgent}
行: ${line}, 列: ${col}
${err ? err.stack : err || ''}`;
    if (IS_DEV) {
      console.log(errMessage);
    } else {
      const now = new Date().getTime();
      if (lastTime && now < lastTime + 60000) {
        return;
      }
      lastTime = now;
      // send error email
    }
  };
})()
